const scrollBehavior = 
	{
		props: {
			visible: {
				default: () => false
			}
		},
	};

export default scrollBehavior